const{registerBlockType}=wp.blocks;
const {RichText, InspectorControls, PanelColorSettings, FontSizePicker} =  wp.blockEditor
import {PanelBody, ToggleControl, BaseControl, SelectControl, RangeControl, TextControl, __experimentalBoxControl as BoxControl, __experimentalBorderBoxControl as BorderBoxControl, __experimentalUnitControl as UnitControl, __experimentalInputControl as InputControl, TextareaControl} from '@wordpress/components';
import FontIconPicker from '@fonticonpicker/react-fonticonpicker';
import {icons} from './lib/icons';
import dropicons from './lib/accordion-icon';
import {fontfamilylist} from "./lib/fontfamilylist.js";
const {__} = wp.i18n;

registerBlockType('spice-blocks/spice-accordion',{
    title:__('Accordion','spice-blocks'),
    category:'spice-blocks',
    icon: <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
     <g><g stroke="null" stroke-opacity="0"><path stroke="#09A223" d="m0.05634,6.02817l0,11.94366l23.88732,0l0,-11.94366l-23.88732,0zm22.39437,10.4507l-20.90141,0l0,-5.97183l20.90141,0l0,5.97183z" fill="#09A223"/><path stroke="#09A223" d="m0.05634,0.05634l23.88732,0l0,4.47887l-23.88732,0l0,-4.47887z" fill="#09A223"/><path stroke="#09A223" d="m0.05634,19.46479l23.88732,0l0,4.47887l-23.88732,0l0,-4.47887z" fill="#09A223"/></g></g></svg>,
     keywords: [
        __('Accordion','spice-blocks'),
        __('Spice Accordion','spice-blocks'),
        __('FAQ','spice-blocks')
     ],
     example: {
        attributes: {
            heading: __('Accordion Heading','spice-blocks')
        }
     },
     attributes: {
        uniqueId: {
            type: 'string'
        },
        accordionHeadingIcon:{
            type:'string',
            default:'fa fa-question-circle-o'
        },
        accordionHeading: {
            type: 'string',
            default: 'Accordion Heading'
        },
        accordionContent: {
            type: 'string',
            default: 'Lorem ipsum dolor sit amet elit dis enean ligula rt felis sociis natoque penatibus et magnis dis parturient dis eget montes.'
        },
        AccordionSectionMargin: {
            default: {
                top: '15px',
                right: '15px',
                bottom: '15px',
                left: '15px'
            }
        },
        AccordionHeadingPaddings: {
            default: {
                top: '15px',
                right: '20px',
                bottom:'16px',
                left: '60px'
            }
        },
        AccordionContentPaddings: {
            default: {
                top: '10px',
                right: '48px',
                bottom: '30px',
                left: '60px'
            }
        },
        AccordionContentIconPaddings: {
            default: {
                top: '15px',
                right: '0',
                bottom: '0',
                left: '15px'
            }
        },
        AccordionToggleIconPaddings: {
            default: {
                top: '10px',
                left: '0',
                right: '5px',
                bottom: '0'
            }
        },
        AccordionShowIcon: {
            type: 'boolean',
            default: true
        },
        AccordionsIconClass: {
            type: 'string',
            default: 'fa-solid fa-plus_fa-solid fa-minus'
        },
        AccordionBorder: {
            default: {
                width: '0',
                color: '#000000',
                style: 'solid'
            }
        },
        AccordionHeadingBorder: {
            default: {
                width: '0',
                color: '#000',
                style: 'solid'
            }
        },
        AccordionTabColor: {
            type: 'string',
            default:'#f5f7fd'
        },
        AccordionTabActiveColor: {
            type: 'string',
            default:'#ffffff'
        },
        AccordionHeadingColor: {
            type: 'string',
            default:'#000000'
        },
        AccordionActiveHeadingColor: {
            type: 'string',
            default:'#000000'
        },
        AccordionBackgroundColor: {
            type: 'string',
            default:'#ffffff'
        },
        AccordionContentColor: {
            type: 'string',
            default:'#707070'
        },
        AccordionIconColor1: {
            type: 'string',
            default:'#898989'
        },
        AccordionIconColor2: {
            type: 'string',
            default:'#7cc048'
        },
        AccordionActiveIconColor1: {
            type: 'string',
            default:'#898989'
        },
        AccordionActiveIconColor2: {
            type: 'string',
            default:'#7cc048'
        },
        AccordionHeadingfontfamily:{
            type:'string',
            default:'Montserrat'
        },
        AccordionHeadingfontSize:{
            type:'string',
            default:'24px'
        },
        AccordionHeadingFontWeight:{
            type: 'string',
            default: 400
        },
        AccordionHeadingLineHeight: {
            type:'number',
            default:32
        },
        AccordionHeadingTextTransform: { 
            type:'string'
        },
        AccordionHeadingTextDecoration: {
            type:'string'
        },
        AccordionHeadingLetterSpacing: {
            type:'number'
        },
        AccordionContentfontfamily:{
            type:'string',
            default:'Montserrat'
        },
        AccordionContentfontSize:{
            type:'string',
            default:'16px'
        },
        AccordionContentFontWeight: {
            type: 'string',
            default: 400
        },
        AccordionContentLineHeight: {
            type:'number',
            default:28
        },
        AccordionContentTextTransform: { 
            type:'string'
        },
        AccordionContentTextDecoration: {
            type:'string'
        },
        AccordionContentLetterSpacing: {
            type:'number'
        },
        AccordionAnimation:{
            type:'string',
            default:''
        },
        AccordionDurations:{
            type:'string'
        },
        AccordionDelay:{
            type:'string'
        }, 
        AccordionHideDesktop:{
            type: 'boolean',
            default: true
        },
        AccordionHideTablet:{
            type: 'boolean',
            default: true
        },
        AccordionHideMobile:{
            type: 'boolean',
            default: true
        },
        hshadow: {
            type: 'number',
            default: 0
        },
        vshadow: {
            type: 'number',
            default: 0
        },
        blurshadow: {
            type: 'number',
            default: 20
        },
        shadowColor:{
            type:'string',
            default:'#dedede'
        },
        headingtopradius:{
	    	type: 'string',
	    	default: '0px'
	    },
	    headingrightradius:{
	    	type: 'string', 
	    	default: '0px' 
	    },
        headingbottomradius:{
	    	type: 'string',
	    	default: '0px'
	    },
	    headingleftradius:{
	    	type: 'string',
	    	default: '0px'
	    },
        paneltopradius:{
	    	type: 'string',
	    	default: '0px'
	    },
	    panelrightradius:{
	    	type: 'string', 
	    	default: '0px' 
	    },
        panelbottomradius:{
	    	type: 'string',
	    	default: '0px'
	    },
	    panelleftradius:{
	    	type: 'string',
	    	default: '0px'
	    },
        addclass:{
            type:'string',
        },
        customcss:{
            type:'string',
        }
     },
     edit: function({attributes, setAttributes, clientId})
     {
        const { uniqueId, accordionHeading, accordionContent, AccordionSectionMargin, AccordionHeadingPaddings, AccordionContentPaddings, AccordionContentIconPaddings, AccordionToggleIconPaddings, AccordionShowIcon, AccordionsIconClass, AccordionBorder, AccordionTabColor, AccordionTabActiveColor, AccordionHeadingColor, AccordionActiveHeadingColor, AccordionBackgroundColor, AccordionContentColor, AccordionIconColor1, AccordionIconColor2, AccordionActiveIconColor1, AccordionActiveIconColor2, AccordionHeadingfontfamily, AccordionHeadingfontSize, AccordionHeadingFontWeight, AccordionHeadingLineHeight, AccordionHeadingTextTransform, AccordionHeadingTextDecoration, AccordionHeadingLetterSpacing, AccordionContentfontfamily, AccordionContentfontSize, AccordionContentFontWeight, AccordionContentLineHeight, AccordionContentTextTransform, AccordionContentTextDecoration, AccordionContentLetterSpacing, accordionHeadingIcon, AccordionAnimation, AccordionDurations, AccordionDelay, AccordionHideDesktop, AccordionHideTablet, AccordionHideMobile, hshadow, vshadow, blurshadow, shadowColor, headingtopradius, headingrightradius, headingbottomradius , headingleftradius, paneltopradius, panelrightradius, panelbottomradius, panelleftradius, AccordionHeadingBorder, addclass, customcss  } = attributes;

        const animationclass='wow animated ' +attributes.AccordionDurations+' '+attributes.AccordionAnimation;
        const displaydesktop=(AccordionHideDesktop == false) ? 'hide-desktop' : '';
        const displaytablet=(AccordionHideTablet == false) ? 'hide-tablet' : '';
        const displaymobile=(AccordionHideMobile == false) ? 'hide-mobile' : '';
        const displayclass=displaydesktop+' '+displaytablet+' '+displaymobile;

        // Border
        const AccordionBordertop=(AccordionBorder.top != undefined) ? `${AccordionBorder.top.width} ${AccordionBorder.top.style} ${AccordionBorder.top.color}` : null;
	    const AccordionBorderright=(AccordionBorder.right != undefined) ? `${AccordionBorder.right.width} ${AccordionBorder.right.style} ${AccordionBorder.right.color}` : null;
	    const AccordionBorderbottom=(AccordionBorder.bottom != undefined) ? `${AccordionBorder.bottom.width} ${AccordionBorder.bottom.style} ${AccordionBorder.bottom.color}` : null;
	    const AccordionBorderleft=(AccordionBorder.left != undefined) ? `${AccordionBorder.left.width} ${AccordionBorder.left.style} ${AccordionBorder.left.color}` : null;

        // Heading Border
        const AccordionHeadingBordertop=(AccordionHeadingBorder.top != undefined) ? `${AccordionHeadingBorder.top.width} ${AccordionHeadingBorder.top.style} ${AccordionHeadingBorder.top.color}` : null;
	    const AccordionHeadingBorderright=(AccordionHeadingBorder.right != undefined) ? `${AccordionHeadingBorder.right.width} ${AccordionHeadingBorder.right.style} ${AccordionHeadingBorder.right.color}` : null;
	    const AccordionHeadingBorderbottom=(AccordionHeadingBorder.bottom != undefined) ? `${AccordionHeadingBorder.bottom.width} ${AccordionHeadingBorder.bottom.style} ${AccordionHeadingBorder.bottom.color}` : null;
	    const AccordionHeadingBorderleft=(AccordionHeadingBorder.left != undefined) ? `${AccordionHeadingBorder.left.width} ${AccordionHeadingBorder.left.style} ${AccordionHeadingBorder.left.color}` : null;

        // set unique ID
        setAttributes({ uniqueId: clientId.slice(0, 8), }); 
    
        if(AccordionHeadingfontfamily !=null){
            let url = 'https://fonts.googleapis.com/css2?family='+AccordionHeadingfontfamily+':wght@100;200;300;400;500;600;700;800;900&display=swap';
            let link = document.createElement('link')
            link.href = url;
            link.rel = "stylesheet";
            link.type =  "text/css";
            
            if ( jQuery("body").hasClass("site-editor-php") ) { 
            jQuery('iframe').contents().find("head").append(link);
        }
        else{
            document.head.appendChild(link);
        }
        } 

        if(AccordionContentfontfamily !=null){
            let url2 = 'https://fonts.googleapis.com/css2?family='+AccordionContentfontfamily+':wght@100;200;300;400;500;600;700;800;900&display=swap';
            let link = document.createElement('link')
            link.href = url2;
            link.rel = "stylesheet";
            link.type =  "text/css";
            
            if ( jQuery("body").hasClass("site-editor-php") ) { 
            jQuery('iframe').contents().find("head").append(link);
        }
        else{
            document.head.appendChild(link);
        }
        }

        const abcdef1="abcdef-1"+uniqueId;
        const abcdef2="abcdef-2"+uniqueId;

        var urlscriptowl010=plugin.pluginpath+'assets/js/jquery.min.js';
        let linkscriptowl010 = document.createElement('script');
        linkscriptowl010.src=urlscriptowl010;
        jQuery('iframe').contents().find("body").append(linkscriptowl010);
        
        var urlfontawesome=plugin.pluginpath+'assets/js/fontawesome.js';
        let linkfontawesome = document.createElement('script');
        linkfontawesome.src=urlfontawesome;
        jQuery('iframe').contents().find('body').append(linkfontawesome);

        var urlaccordion=plugin.pluginpath+'assets/js/accordion.js';
        let linkaccordion = document.createElement('script');
        linkaccordion.src=urlaccordion;
        jQuery('iframe').contents().find('body').append(linkaccordion);

        return([<>
            <InspectorControls>
                <PanelBody initialOpen={true} title={__('General Settings','spice-blocks')}>
                    <PanelBody initialOpen={false} title={__('Spacing','spice-blocks')} className={'spice-panel-edit margin'}>
                        <BoxControl 
                            label={__('Section Margin','spice-blocks')}
                            values={AccordionSectionMargin}
                            sides={['top', 'bottom','left','right']}
                            inputProps={{ min: -300 }}
                            allowReset={false}
                            units={[]}
                            onChange={(userVal) => setAttributes({
                                AccordionSectionMargin:{
                                top:userVal.top,
                                right:userVal.right,
                                bottom:userVal.bottom,
                                left:userVal.left
                                }
                            })}
                        />
                        
                        <BoxControl 
                            label={__('Title Padding','spice-blocks')}
                            values={AccordionHeadingPaddings}
                            sides={['top', 'bottom','left','right']}
                            allowReset={false}
                            units={[]}
                            onChange={(userVal) => setAttributes({
                                AccordionHeadingPaddings:{
                                top:userVal.top,
                                right:userVal.right,
                                bottom:userVal.bottom,
                                left:userVal.left
                                }
                            })}
                        />
                        <BoxControl 
                            label={__('Content Padding','spice-blocks')}
                            values={AccordionContentPaddings}
                            sides={['top', 'bottom','left','right']}
                            allowReset={false}
                            units={[]}
                            onChange={(userVal) => setAttributes({
                                AccordionContentPaddings:{
                                top:userVal.top,
                                right:userVal.right,
                                bottom:userVal.bottom,
                                left:userVal.left
                                }
                            })}
                        />
                    </PanelBody>

                    <PanelBody initialOpen={false} title={__('Border','spice-blocks')} className={'spice-panel-edit margin'}>
                        <BaseControl className="spice-blocks-border-radius" label={__('Heading Border Radius','spice-blocks')} __nextHasNoMarginBottom={ true }>
			                <UnitControl className={"border-radius-top"} onChange={ (newtext) => setAttributes({ headingtopradius: newtext }) } value={ headingtopradius } placeholder={"Top"} />
			                <UnitControl className={"border-radius-right"} onChange={ (newtext) => setAttributes({ headingrightradius: newtext }) } value={ headingrightradius } placeholder={"right"} />			        
			                <UnitControl className={"border-radius-left"} onChange={ (newtext) => setAttributes({ headingbottomradius: newtext }) } value={ headingbottomradius } placeholder={"left"}/>
			                <UnitControl className={"border-radius-bottom"}  onChange={ (newtext) => setAttributes({ headingleftradius: newtext }) } value={ headingleftradius }  placeholder={"bottom"}/>	       
		                </BaseControl>

                        <BorderBoxControl 
                            label={__('Heading Border', 'spice-blocks')}
                            enableAlpha={'true'}
                            value={AccordionHeadingBorder}
                            onChange={(userVal) => setAttributes({AccordionHeadingBorder:userVal})}
                        />

                        <BaseControl className="spice-blocks-border-radius" label={__('Panel Border Radius','spice-blocks')} __nextHasNoMarginBottom={ true }>
			                <UnitControl className={"border-radius-top"} onChange={ (newtext) => setAttributes({ paneltopradius: newtext }) } value={ paneltopradius } placeholder={"Top"} />
			                <UnitControl className={"border-radius-right"} onChange={ (newtext) => setAttributes({panelrightradius: newtext }) } value={ panelrightradius } placeholder={"right"} />			        
			                <UnitControl className={"border-radius-left"} onChange={ (newtext) => setAttributes({ panelbottomradius: newtext }) } value={ panelbottomradius } placeholder={"left"}/>
			                <UnitControl className={"border-radius-bottom"}  onChange={ (newtext) => setAttributes({ panelleftradius: newtext }) } value={ panelleftradius }  placeholder={"bottom"}/>	       
		                </BaseControl>

                        <BorderBoxControl 
                            label={__('Panel Border', 'spice-blocks')}
                            enableAlpha={'true'}
                            value={AccordionBorder}
                            onChange={(userVal) => setAttributes({AccordionBorder:userVal})}
                        />
                    </PanelBody>

                    <PanelBody initialOpen={false} title={__('Animation Effect','spice-blocks')} className={'spice-panel-edit margin'}>
                        <SelectControl
                            label={__('Animation','spice-block-plus')}
                            value={ AccordionAnimation }
                            options={ [
                                { label: __('None','spice-blocks'), value: ' ' },
                                { label: __('Bounce','spice-blocks'), value: 'bounce' },
                                { label: __('Flash','spice-blocks'), value: 'flash' },
                                { label: __('Pulse','spice-blocks'), value: 'pulse' },
                                { label: __('RubberBand','spice-blocks'), value: 'rubberBand' },
                                { label: __('Shake','spice-blocks'), value: 'shake' },
                                { label: __('Swing','spice-blocks'), value: 'swing' },
                                { label: __('Tada','spice-blocks'), value: 'tada' },
                                { label: __('Wobble','spice-blocks'), value: 'wobble' },
                                { label: __('Jello','spice-blocks'), value: 'jello' },
                                { label: __('BounceIn','spice-blocks'), value: 'bounceIn' },
                                { label: __('BounceInDown','spice-blocks'), value: 'bounceInDown' },
                                { label: __('BounceInLeft','spice-blocks'), value: 'bounceInLeft' },
                                { label: __('BounceInRight','spice-blocks'), value: 'bounceInRight' },
                                { label: __('BounceInUp','spice-blocks'), value: 'bounceInUp' },
                                { label: __('FadeIn','spice-blocks'), value: 'fadeIn' },
                                { label: __('FadeInDown','spice-blocks'), value: 'fadeInDown' },
                                { label: __('FadeInDownBig','spice-blocks'), value: 'fadeInDownBig' },
                                { label: __('FadeInLeft','spice-blocks'), value: 'fadeInLeft' },
                                { label: __('FadeInLeftBig','spice-blocks'), value: 'fadeInLeftBig' },
                                { label: __('FadeInRight','spice-blocks'), value: 'fadeInRight' },
                                { label: __('FadeInRightBig','spice-blocks'), value: 'fadeInRightBig' },
                                { label: __('FadeInUp','spice-blocks'), value: 'fadeInUp' },
                                { label: __('FadeInUpBig','spice-blocks'), value: 'fadeInUpBig' },
                                { label: __('Flip','spice-blocks'), value: 'flip' },
                                { label: __('FlipInX','spice-blocks'), value: 'flipInX' },
                                { label: __('FlipInY','spice-blocks'), value: 'flipInY' },
                                { label: __('LightSpeedIn','spice-blocks'), value: 'lightSpeedIn' },
                                { label: __('RollIn','spice-blocks'), value: 'rollIn' },
                                { label: __('RotateIn','spice-blocks'), value: 'rotateIn' },
                                { label: __('RotateInDownLeft','spice-blocks'), value: 'rotateInDownLeft' },
                                { label: __('RotateInDownRight','spice-blocks'), value: 'rotateInDownRight' },
                                { label: __('RotateInUpLeft','spice-blocks'), value: 'rotateInUpLeft' },
                                { label: __('RotateInUpRight','spice-blocks'), value: 'rotateInUpRight' },
                                { label: __('SlideInDown','spice-blocks'), value: 'slideInDown' },
                                { label: __('SlideInLeft','spice-blocks'), value: 'slideInLeft' },
                                { label: __('SlideInRight','spice-blocks'), value: 'slideInRight' },
                                { label: __('ZoomIn','spice-blocks'), value: 'zoomIn' },
                                { label: __('ZoomInDown','spice-blocks'), value: 'zoomInDown' },
                                { label: __('ZoomInLeft','spice-blocks'), value: 'zoomInLeft' },
                                { label: __('ZoomInRight','spice-blocks'), value: 'zoomInRight' },
                                { label: __('ZoomInUp','spice-blocks'), value: 'zoomInUp' }
                            ] }
                            onChange={ (userVal) => setAttributes({ AccordionAnimation: userVal }) }					  
                        />  
                        { AccordionAnimation !="" && ( <>
                        <SelectControl
                            label={__('Durations','spice-block-plus')}
                            value={ AccordionDurations }
                            options={ [
                                { label: __('Normal','spice-blocks'), value: ' ' },
                                { label: __('Slow','spice-blocks'), value: 'slow' },
                                { label: __('Fast','spice-blocks'), value: 'fast' },
                            ] }
                            onChange={ (userVal) => setAttributes({ AccordionDurations: userVal }) }					  
                        />  
                        <TextControl
                            label={__('Delay(ms)','spice-block-plus')}			    
                            value={AccordionDelay}
                            onChange={(userVal) => setAttributes({ AccordionDelay: userVal })}
                        />
                        </>)}
                    </PanelBody>
                
                    <PanelBody initialOpen={false} title={__('Display','spice-blocks')} className={'spice-panel-edit margin'}>
                        <ToggleControl
                            label={__('Enable/Disable on Desktop','spice-blocks')}
                            checked={AccordionHideDesktop}
                            onChange={(userVal) => setAttributes({ AccordionHideDesktop: userVal })}
                        />
                        <ToggleControl
                            label={__('Enable/Disable on Tablet','spice-blocks')}
                            checked={AccordionHideTablet}
                            onChange={(userVal) => setAttributes({ AccordionHideTablet: userVal })}
                        />
                        <ToggleControl
                            label={__('Enable/Disable on Mobile','spice-blocks')}
                            checked={AccordionHideMobile}
                            onChange={(userVal) => setAttributes({ AccordionHideMobile: userVal })}
                        />
                    </PanelBody> 
                </PanelBody>

                <PanelBody initialOpen={false} title={__('Icon Settings','spice-blocks')} className={'spice-block-side-margin'}>
                    <BaseControl className='spice-blocks-plus-accordion-icon1' id="spice-blocks-plus-accordion-icon1" label={__('Icons 1','spice-blocks')}>
                        <FontIconPicker
                            theme={"default spicegbicon "+uniqueId}																				
                            icons={icons}
                            value={accordionHeadingIcon}
                            onChange={(userVal) => setAttributes({ accordionHeadingIcon: userVal })}
                        />
                    </BaseControl> 
                    <BoxControl 
                     label={__('Icon 1 Padding( Top & Left )','spice-blocks')}
                     values={AccordionContentIconPaddings}
                     sides={['top', 'left']}
                     allowReset={false}
                     units={[]}
                     onChange={(userVal) => setAttributes({
                        AccordionContentIconPaddings:{
                           top:userVal.top,
                           right:userVal.right,
                           bottom:userVal.bottom,
                           left:userVal.left
                        }
                     })}
                    />
                    <ToggleControl 
						   label={__('Enable/Disable Icons 2','spice-blocks')}
						   checked={AccordionShowIcon}
						   onChange={() => setAttributes({AccordionShowIcon: !AccordionShowIcon})}
					   />
					   { AccordionShowIcon && [<>
                            <SelectControl 
                                label={__('Select Icon','spice-blocks')}
                                value={AccordionsIconClass}
                                options={dropicons}
                                onChange={(userVal) => setAttributes({AccordionsIconClass:userVal})}
                            />
                            <BoxControl 
                                label={__('Icon 2 Padding ( Top & right )','spice-blocks')}
                                values={AccordionToggleIconPaddings}
                                sides={['top', 'right']}
                                allowReset={false}
                                units={[]}
                                onChange={(userVal) => setAttributes({
                                    AccordionToggleIconPaddings:{
                                    top:userVal.top,
                                    right:userVal.right,
                                    bottom:userVal.bottom,
                                    left:userVal.left
                                    }
                                })}
                            /> 
                        </>
                    ]}
                  
               
                    
               </PanelBody>

               <PanelBody initialOpen={false} title={__('Panel Box Shadow','spice-blocks')} className={'spice-block-side-margin'}>	
                    <RangeControl 
                        label={__('Horizontal Shadow(px)','spice-blocks')}			    
                        value={ hshadow}
                        onChange={(userVal) => setAttributes({ hshadow: userVal })}
                        min={0}
                        max={100}
                    />
                    <RangeControl 
                        label={__('Vertical Shadow(px)','spice-blocks')}			    
                        value={ vshadow} onChange={(userVal) => setAttributes({ vshadow: userVal })}
                        min={0}
                        max={100}
                    />	
                    <RangeControl 
                        label={__('Blur Shadow(px)','spice-blocks')}			    
                        value={ blurshadow}
                        onChange={(userVal) => setAttributes({ blurshadow: userVal })}
                        min={0}
                        max={100}
                    />
                    <PanelColorSettings initialOpen={false} className={"spice-block-color-tab-panel"}
                        title={__('Background & Color Settings','spice-block-plus')}
                        colorSettings={[
                            {
                                value: shadowColor,
                                enableAlpha:true,
                                onChange: (colors) => setAttributes({ shadowColor: colors }),
                                label: __('Box Shadow','spice-blocks')
                            },
                        ]}
                    />
                </PanelBody>

                <PanelBody initialOpen={false} title={__('Color Settings','spice-blocks')}>    
                    <PanelColorSettings initialOpen={false} className={"spice-block-color-tab-panel"}
                            title={__('Color Settings','spice-blocks')}
                            colorSettings={[
                                {
                                    value: AccordionTabColor,
                                    enableAlpha:true,
                                    onChange: (colors) => setAttributes({ AccordionTabColor: colors }),
                                    label: __('Tab','spice-blocks')
                                },
                                {
                                    value: AccordionHeadingColor,
                                    enableAlpha:true,
                                    onChange: (colors) => setAttributes({ AccordionHeadingColor: colors }),
                                    label: __('Heading','spice-blocks')
                                },
                                {
                                    value: AccordionIconColor1,
                                    enableAlpha:true,
                                    onChange: (colors) => setAttributes({ AccordionIconColor1: colors }),
                                    label: __('Icon 1','spice-blocks')
                                },
                                {
                                    value: AccordionIconColor2,
                                    enableAlpha:true,
                                    onChange: (colors) => setAttributes({ AccordionIconColor2: colors }),
                                    label: __('Icon 2','spice-blocks')
                                },
                                {
                                    value: AccordionTabActiveColor,
                                    enableAlpha:true,
                                    onChange: (colors) => setAttributes({ AccordionTabActiveColor: colors }),
                                    label: __('Opened/Active Tab','spice-blocks')
                                },
                                {
                                    value: AccordionActiveHeadingColor,
                                    enableAlpha:true,
                                    onChange: (colors) => setAttributes({ AccordionActiveHeadingColor: colors }),
                                    label: __('Opened/Active Heading','spice-blocks')
                                },
                                {
                                    value: AccordionBackgroundColor,
                                    enableAlpha:true,
                                    onChange: (colors) => setAttributes({ AccordionBackgroundColor: colors }),
                                    label: __('Panel Background','spice-blocks')
                                },
                                {
                                    value: AccordionContentColor,
                                    enableAlpha:true,
                                    onChange: (colors) => setAttributes({ AccordionContentColor: colors }),
                                    label: __('Content','spice-blocks')
                                },
                                {
                                    value: AccordionActiveIconColor1,
                                    enableAlpha:true,
                                    onChange: (colors) => setAttributes({ AccordionActiveIconColor1: colors }),
                                    label: __('Opened/Active Icon 1','spice-blocks')
                                },
                                {
                                    value: AccordionActiveIconColor2,
                                    enableAlpha:true,
                                    onChange: (colors) => setAttributes({ AccordionActiveIconColor2: colors }),
                                    label: __('Opened/Active Icon 2','spice-blocks')
                                }
                            ]}  
                        />
                </PanelBody>

                <PanelBody initialOpen={false} title={__('Typography Settings','spice-blocks')}>
                    <PanelBody initialOpen={false} title={__('Heading Typography','spice-blocks')}  className={'spice-block-side-margin'}>
                        <SelectControl
                            label={__(' Font Family','spice-blocks')}
                            value={ AccordionHeadingfontfamily }
                            options={fontfamilylist}
                            onChange={ (userVal) => setAttributes({ AccordionHeadingfontfamily: userVal }) }                      
                        />   

                        <FontSizePicker 
                            __nextHasNoMarginBottom
                            value={ AccordionHeadingfontSize }
                            onChange={(userVal) => setAttributes({AccordionHeadingfontSize: userVal})}
                        />

                        <SelectControl
                            label={__('Font Weight','spice-blocks')}
                            options= {[
                                { label: __('Thin','spice-blocks'), value: '100' },
                                { label: __('Extra Light','spice-blocks'), value: '200' },
                                { label: __('Light','spice-blocks'), value: '300' },
                                { label: __('Regular','spice-blocks'), value: '400' },
                                { label: __('Medium','spice-blocks'), value: '500' },
                                { label: __('Semi Bold','spice-blocks'), value: '600' },
                                { label: __('Bold','spice-blocks'), value: '700' },
                                { label: __('Extra Bold','spice-blocks'), value: '800' },
                                { label: __('Black','spice-blocks'), value: '900' }
                            ]}
                            value={AccordionHeadingFontWeight}
                            onChange={ (userVal) => setAttributes({ AccordionHeadingFontWeight: userVal }) }
                        />

                        <RangeControl 
                            label={__('line Height (px)','spice-blocks')}
                            value={AccordionHeadingLineHeight}
                            min={0}
                            max={100}
                            onChange={(userVal) => setAttributes({AccordionHeadingLineHeight: userVal})}
                        />

                        <SelectControl
                            label={__('Text Transform','spice-blocks')}
                            options={[
                                { label: __('Default','spice-blocks'), value: '' },
                                { label: __('Uppercase','spice-blocks'), value: 'uppercase' },
                                { label: __('Lowercase','spice-blocks'), value: 'lowercase' },
                                { label: __('Capitalize','spice-blocks'), value: 'capitalize' }
                            ]}
                            value={AccordionHeadingTextTransform}
                            onChange={(userVal) => setAttributes({AccordionHeadingTextTransform:userVal})}
                        />

                        <SelectControl 
                            label={__('Text Decoration','spice-blocks')}
                            options={[
                                { label: __('Default','spice-blocks'), value: '' },
                                { label: __('Underline','spice-blocks'), value: 'underline' },
                                { label: __('Overline','spice-blocks'), value: 'overline' },
                                { label: __('Line Through','spice-blocks'), value: 'line-through' }
                            ]}
                            value={AccordionHeadingTextDecoration}
                            onChange={(userVal) => setAttributes({AccordionHeadingTextDecoration:userVal})}
                        />

                        <RangeControl 
                            label={__('Letter Spacing  (px)','spice-blocks')}
                            value={AccordionHeadingLetterSpacing}
                            min={-10.0}
                            max={10.0}
                            onChange={(userVal)=> setAttributes({AccordionHeadingLetterSpacing:userVal})}
                        />
                    </PanelBody>

                    <PanelBody initialOpen={false} title={__('Content Typography','spice-blocks')}  className={'spice-block-side-margin'}>
                        <SelectControl 
                            label={__('Font Family','spice-blocks')}
                            options={fontfamilylist}
                            value={AccordionContentfontfamily}
                            onChange={(userVal) => setAttributes({AccordionContentfontfamily:userVal})}
                        />

                        <FontSizePicker 
                            __nextHasNoMarginBottom
                             value={AccordionContentfontSize}
                             onChange={(userVal) => setAttributes({AccordionContentfontSize: userVal})}
                        />

                        <SelectControl 
                            label={__('Font Weight','spice-blocks')}
                            options= {[
                                { label: __('Thin','spice-blocks'), value: '100' },
                                { label: __('Extra Light','spice-blocks'), value: '200' },
                                { label: __('Light','spice-blocks'), value: '300' },
                                { label: __('Regular','spice-blocks'), value: '400' },
                                { label: __('Medium','spice-blocks'), value: '500' },
                                { label: __('Semi Bold','spice-blocks'), value: '600' },
                                { label: __('Bold','spice-blocks'), value: '700' },
                                { label: __('Extra Bold','spice-blocks'), value: '800' },
                                { label: __('Black','spice-blocks'), value: '900' }
                            ]}
                            value={ AccordionContentFontWeight}
                            onChange={(userVal) => setAttributes({AccordionContentFontWeight: userVal})}
                        />

                        <RangeControl 
                            label={__('line Height(px)','spice-blocks')}
                            value={AccordionContentLineHeight}
                            min={0}
                            max={100}
                            onChange={(userVal)=> setAttributes({AccordionContentLineHeight:userVal})}
                        />

                        <SelectControl 
                            label={__('Text Transform','spice-blocks')}
                            options={[
                                { label: __('Default','spice-blocks'), value: '' },
                                { label: __('Uppercase','spice-blocks'), value: 'uppercase' },
                                { label: __('Lowercase','spice-blocks'), value: 'lowercase' },
                                { label: __('Capitalize','spice-blocks'), value: 'capitalize' }
                            ]}
                            value={AccordionContentTextTransform}
                            onChange={(userVal) => setAttributes({AccordionContentTextTransform: userVal})}
                        />

                        <SelectControl 
                            label={__('Text Decoration','spice-blocks')}
                            options={[
                                { label: __('Default','spice-blocks'), value: '' },
                                { label: __('Underline','spice-blocks'), value: 'underline' },
                                { label: __('Overline','spice-blocks'), value: 'overline' },
                                { label: __('Line Through','spice-blocks'), value: 'line-through' }
                            ]}
                            value={AccordionContentTextDecoration}
                            onChange={(userVal) => setAttributes({AccordionContentTextDecoration: userVal})} 
                        />

                        <RangeControl 
                            label={__('Letter Spacing  (px)','spice-blocks')}
                            value={AccordionContentLetterSpacing}
                            min={-10.0}
                            max={10.0}
                            onChange={(userVal) => setAttributes({AccordionContentLetterSpacing: userVal})}
                        />

                    </PanelBody>
                </PanelBody>
                <PanelBody initialOpen={false} title={__('Additional Settings','spice-blocks')}>
                    <InputControl
                        label={__('Additional Class','spice-blocks')}
                        value={ addclass }
                        onChange={ (userVal)=> setAttributes({addclass:userVal}) }
                    />
                    <TextareaControl
                        label={__('Custom CSS','spice-blocks')}
                        value={ customcss }
                        onChange={ (userVal)=> setAttributes({customcss:userVal}) }
                    />
                </PanelBody>
            </InspectorControls>
            <style dangerouslySetInnerHTML={{
			  __html: [
			     `#block-${clientId} .spice-gp-accordion-section{
                    margin:${AccordionSectionMargin.top} ${AccordionSectionMargin.right} ${AccordionSectionMargin.bottom} ${AccordionSectionMargin.left};
                    animation-delay: ${AccordionDelay}ms;
                 }
                 #block-${clientId} .spice-gp-accordion-section .before-icon{
                    padding: ${AccordionContentIconPaddings.top} ${AccordionContentIconPaddings.right} ${AccordionContentIconPaddings.bottom} ${AccordionContentIconPaddings.left};
                    margin:0;
                 }
                 #block-${clientId} .spice-gp-accordion-section .before-icon > i {
                    color: ${AccordionIconColor1};
                 }
                 #block-${clientId} .spice-gp-accordion-section .spice-gp-accordion
                 {
                    background:${AccordionTabColor};
                    color:${AccordionHeadingColor};
                    font-family:${AccordionHeadingfontfamily ? AccordionHeadingfontfamily : 'Montserrat, sans-serif'};
                    font-size: ${AccordionHeadingfontSize};
                    font-weight: ${AccordionHeadingFontWeight};
                    line-height: ${AccordionHeadingLineHeight}px;
                    text-transform:${AccordionHeadingTextTransform};
                    text-decoration:${AccordionHeadingTextDecoration};
                    letter-spacing:${AccordionHeadingLetterSpacing}px;
                    padding:${AccordionHeadingPaddings.top} ${AccordionHeadingPaddings.right} ${AccordionHeadingPaddings.bottom} ${AccordionHeadingPaddings.left};
                    border-radius: ${headingtopradius} ${headingrightradius} ${headingbottomradius} ${headingleftradius};
                    border: ${AccordionHeadingBorder.width} ${AccordionHeadingBorder.style} ${AccordionHeadingBorder.color};
                    border-top:${AccordionHeadingBordertop};
					border-right:${AccordionHeadingBorderright};
					border-bottom:${AccordionHeadingBorderbottom};
					border-left:${AccordionHeadingBorderleft};
                 }
                 #block-${clientId} .spice-gp-accordion-section .after-icon-one
                 {
                    color:${AccordionIconColor2};
                    padding:${AccordionToggleIconPaddings.top} ${AccordionToggleIconPaddings.right} ${AccordionToggleIconPaddings.bottom} ${AccordionToggleIconPaddings.left};
                    margin:0;
                 }
                 #block-${clientId} .spice-gp-accordion-section .after-icon-two
                 {
                    color:${AccordionActiveIconColor2};
                    padding:${AccordionToggleIconPaddings.top} ${AccordionToggleIconPaddings.right} ${AccordionToggleIconPaddings.bottom} ${AccordionToggleIconPaddings.left};
                 }
                 #block-${clientId} .spice-gp-accordion-section p
                 {
                    background:${AccordionBackgroundColor};
                    color:${AccordionContentColor};
                    font-family:${AccordionContentfontfamily ? AccordionContentfontfamily : 'Montserrat, sans-serif'};
                    font-size: ${AccordionContentfontSize};
                    font-weight: ${AccordionContentFontWeight};
                    line-height: ${AccordionContentLineHeight}px;
                    text-transform:${AccordionContentTextTransform};
                    text-decoration:${AccordionContentTextDecoration};
                    letter-spacing:${AccordionContentLetterSpacing}px;
                    text-align:left;
                    padding:${AccordionContentPaddings.top} ${AccordionContentPaddings.right} ${AccordionContentPaddings.bottom} ${AccordionContentPaddings.left};
                 }
                 #spice_gp_accordion_${uniqueId} .spice-gp-accordion-box.active{
                    border: ${AccordionBorder.width} ${AccordionBorder.style} ${AccordionBorder.color};
                    border-top:${AccordionBordertop};
					border-right:${AccordionBorderright};
					border-bottom:${AccordionBorderbottom};
					border-left:${AccordionBorderleft};
                    box-shadow: ${hshadow}px ${vshadow}px ${blurshadow}px ${shadowColor};
                    border-radius: ${paneltopradius} ${panelrightradius} ${panelbottomradius} ${panelleftradius};
                    overflow:hidden;
				}`,
                `body #spice_gp_accordion_${uniqueId} .spice-gp-accordion-box.active .spice-gp-accordion{
                    background: ${AccordionTabActiveColor};
                    color: ${AccordionActiveHeadingColor};
                    border:0;
				}`,
                `body #spice_gp_accordion_${uniqueId} .spice-gp-accordion-box.active .before-icon i{
                    color: ${AccordionActiveIconColor1};
				}`,
                `#spice_gp_accordion_${uniqueId} #spice_gp_false.spice-gp-accordion-box.active{
                    box-shadow: none;
				}
                ${customcss}`,
			    ].join('\n')
			  }}>
			</style>
            </>,
            <>
            <section className={`spice-gp-accordion-section ${animationclass} ${displayclass} ${addclass}`} >
                <div class="block-container">
                    <div class="block-row">
                        <div class="block-col-12" id={`spice_gp_accordion_${uniqueId}`}> 
                            <div className={`spice-gp-accordion-box`} >
                                <div class="spice-gp-accordion-wrap">
                                    <span class="before-icon"><i className={accordionHeadingIcon}></i></span>
                                    <RichText 
                                        tagName="h2"
                                        className= {`spice-gp-accordion` }
                                        value={accordionHeading}
                                        onChange={(userVal) => setAttributes({accordionHeading: userVal})}
                                    />
                                    { AccordionShowIcon == true && [<>
                                    <span class="after-icon-one" ><i className={`${AccordionsIconClass.split('_')[0]}`}></i></span>
                                    <span class="after-icon-two"><i className={`${AccordionsIconClass.split('_')[1]}`}></i></span>
                                    </>]}
                                    
                                </div>
                                <div class="spice_panel">
                                    <RichText
                                        tagName="p"
                                        value={accordionContent}
                                        onChange={(userVal) => setAttributes({accordionContent: userVal})}
                                       
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div id={abcdef1}></div>
            <div id={abcdef2}></div>
            </>]);
     },
     save: function({attributes})
     {
      const { uniqueId, accordionHeading, accordionContent, AccordionSectionMargin, AccordionHeadingPaddings, AccordionContentPaddings, AccordionContentIconPaddings, AccordionToggleIconPaddings, AccordionShowIcon, AccordionsIconClass, AccordionBorder, AccordionTabColor, AccordionTabActiveColor, AccordionHeadingColor, AccordionActiveHeadingColor, AccordionBackgroundColor, AccordionContentColor, AccordionIconColor1, AccordionIconColor2, AccordionActiveIconColor1, AccordionActiveIconColor2, AccordionHeadingfontfamily, AccordionHeadingfontSize, AccordionHeadingFontWeight, AccordionHeadingLineHeight, AccordionHeadingTextTransform, AccordionHeadingTextDecoration, AccordionHeadingLetterSpacing, AccordionContentfontfamily, AccordionContentfontSize, AccordionContentFontWeight, AccordionContentLineHeight, AccordionContentTextTransform, AccordionContentTextDecoration, AccordionContentLetterSpacing, accordionHeadingIcon, AccordionAnimation, AccordionDurations, AccordionDelay, AccordionHideDesktop, AccordionHideTablet, AccordionHideMobile, hshadow, vshadow, blurshadow, shadowColor, headingtopradius, headingrightradius, headingbottomradius, headingleftradius, paneltopradius, panelrightradius, panelbottomradius, panelleftradius, AccordionHeadingBorder, addclass, customcss } = attributes;

      const animationclass='wow animated ' +attributes.AccordionDurations+' '+attributes.AccordionAnimation;
      const displaydesktop=(AccordionHideDesktop == false) ? 'hide-desktop' : '';
      const displaytablet=(AccordionHideTablet == false) ? 'hide-tablet' : '';
      const displaymobile=(AccordionHideMobile == false) ? 'hide-mobile' : '';
      const displayclass=displaydesktop+' '+displaytablet+' '+displaymobile;

      //Border
      const AccordionBordertop=(AccordionBorder.top != undefined) ? `${AccordionBorder.top.width} ${AccordionBorder.top.style} ${AccordionBorder.top.color}` : null;
      const AccordionBorderright=(AccordionBorder.right != undefined) ? `${AccordionBorder.right.width} ${AccordionBorder.right.style} ${AccordionBorder.right.color}` : null;
      const AccordionBorderbottom=(AccordionBorder.bottom != undefined) ? `${AccordionBorder.bottom.width} ${AccordionBorder.bottom.style} ${AccordionBorder.bottom.color}` : null;
      const AccordionBorderleft=(AccordionBorder.left != undefined) ? `${AccordionBorder.left.width} ${AccordionBorder.left.style} ${AccordionBorder.left.color}` : null; 

       //Heading Border
       const AccordionHeadingBordertop=(AccordionHeadingBorder.top != undefined) ? `${AccordionHeadingBorder.top.width} ${AccordionHeadingBorder.top.style} ${AccordionHeadingBorder.top.color}` : null;
       const AccordionHeadingBorderright=(AccordionHeadingBorder.right != undefined) ? `${AccordionHeadingBorder.right.width} ${AccordionHeadingBorder.right.style} ${AccordionHeadingBorder.right.color}` : null;
       const AccordionHeadingBorderbottom=(AccordionHeadingBorder.bottom != undefined) ? `${AccordionHeadingBorder.bottom.width} ${AccordionHeadingBorder.bottom.style} ${AccordionHeadingBorder.bottom.color}` : null;
       const AccordionHeadingBorderleft=(AccordionHeadingBorder.left != undefined) ? `${AccordionHeadingBorder.left.width} ${AccordionHeadingBorder.left.style} ${AccordionHeadingBorder.left.color}` : null;
        return(<>
                <script> 
					var AccordionHeadingfontfamily=`{AccordionHeadingfontfamily}`;
					var url = 'https://fonts.googleapis.com/css2?family='+AccordionHeadingfontfamily+':wght@100;200;300;400;500;600;700;800;900&display=swap';
					var link = document.createElement('link');
					link.href = url;
					link.rel = "stylesheet";
					link.type =  "text/css";	          
					document.head.appendChild(link);
				</script>	
                <script> 
					var AccordionContentfontfamily=`{AccordionContentfontfamily}`;
					var url2 = 'https://fonts.googleapis.com/css2?family='+AccordionContentfontfamily+':wght@100;200;300;400;500;600;700;800;900&display=swap';
					var link2 = document.createElement('link');
					link2.href = url2;
					link2.rel = "stylesheet";
					link2.type =  "text/css";	          
					document.head.appendChild(link2);
				</script>	
        <style dangerouslySetInnerHTML={{
			  __html: [
			     `#spice_block_plus_accordion_${uniqueId}{
                    margin:${AccordionSectionMargin.top} ${AccordionSectionMargin.right} ${AccordionSectionMargin.bottom} ${AccordionSectionMargin.left};
                    animation-delay: ${AccordionDelay}ms;
                 }
                 #spice_block_plus_accordion_${uniqueId} .before-icon{
                    padding: ${AccordionContentIconPaddings.top} ${AccordionContentIconPaddings.right} ${AccordionContentIconPaddings.bottom} ${AccordionContentIconPaddings.left};
                    margin:0;
                 }
                 #spice_block_plus_accordion_${uniqueId} .before-icon > i {
                    color: ${AccordionIconColor1};
                 }
                 #spice_block_plus_accordion_${uniqueId} .spice-gp-accordion
                 {
                    background:${AccordionTabColor};
                    color:${AccordionHeadingColor};
                    font-family:${AccordionHeadingfontfamily};
                    font-size: ${AccordionHeadingfontSize};
                    font-weight: ${AccordionHeadingFontWeight};
                    line-height: ${AccordionHeadingLineHeight}px;
                    text-transform:${AccordionHeadingTextTransform};
                    text-decoration:${AccordionHeadingTextDecoration};
                    letter-spacing:${AccordionHeadingLetterSpacing}px;
                    padding:${AccordionHeadingPaddings.top} ${AccordionHeadingPaddings.right} ${AccordionHeadingPaddings.bottom} ${AccordionHeadingPaddings.left};
                    border-radius: ${headingtopradius} ${headingrightradius} ${headingbottomradius} ${headingleftradius};
                    border: ${AccordionHeadingBorder.width} ${AccordionHeadingBorder.style} ${AccordionHeadingBorder.color};
                    border-top:${AccordionHeadingBordertop};
					border-right:${AccordionHeadingBorderright};
					border-bottom:${AccordionHeadingBorderbottom};
					border-left:${AccordionHeadingBorderleft};
                 }
                 #spice_block_plus_accordion_${uniqueId} .after-icon-one
                 {
                    color:${AccordionIconColor2};
                    padding:${AccordionToggleIconPaddings.top} ${AccordionToggleIconPaddings.right} ${AccordionToggleIconPaddings.bottom} ${AccordionToggleIconPaddings.left};
                    margin:0;
                 }
                 #spice_block_plus_accordion_${uniqueId} .after-icon-two
                 {
                    color:${AccordionActiveIconColor2};
                    padding:${AccordionToggleIconPaddings.top} ${AccordionToggleIconPaddings.right} ${AccordionToggleIconPaddings.bottom} ${AccordionToggleIconPaddings.left};
                 }
                 #spice_block_plus_accordion_${uniqueId}  p
                 {
                    background:${AccordionBackgroundColor};
                    color:${AccordionContentColor};
                    font-family:${AccordionContentfontfamily};
                    font-size: ${AccordionContentfontSize};
                    font-weight: ${AccordionContentFontWeight};
                    line-height: ${AccordionContentLineHeight}px;
                    text-transform:${AccordionContentTextTransform};
                    text-decoration:${AccordionContentTextDecoration};
                    letter-spacing:${AccordionContentLetterSpacing}px;
                    text-align: left;
                    padding:${AccordionContentPaddings.top} ${AccordionContentPaddings.right} ${AccordionContentPaddings.bottom} ${AccordionContentPaddings.left};
                 }
                 #spice_gp_accordion_${uniqueId} .spice-gp-accordion-box.active{
                    border: ${AccordionBorder.width} ${AccordionBorder.style} ${AccordionBorder.color};
                    border-top:${AccordionBordertop};
					border-right:${AccordionBorderright};
					border-bottom:${AccordionBorderbottom};
					border-left:${AccordionBorderleft};
                    box-shadow: ${hshadow}px ${vshadow}px ${blurshadow}px ${shadowColor};
                    border-radius: ${paneltopradius} ${panelrightradius} ${panelbottomradius} ${panelleftradius};
                    overflow: hidden;
				}`,
                `body #spice_gp_accordion_${uniqueId} .spice-gp-accordion-box.active .spice-gp-accordion{
                    background: ${AccordionTabActiveColor};
                    color: ${AccordionActiveHeadingColor};
                    border:0;
				}`,
                `body #spice_gp_accordion_${uniqueId} .spice-gp-accordion-box.active .before-icon i{
                    color: ${AccordionActiveIconColor1};
				}`,
                `#spice_gp_accordion_${uniqueId} #spice_gp_false.spice-gp-accordion-box.active{
                    box-shadow: none;
				}
                ${customcss}`,
			    ].join('\n')
			  }}>
		</style>
        <section id={`spice_block_plus_accordion_${uniqueId}`} className={`spice-gp-accordion-section ${animationclass} ${displayclass}  ${addclass}`}>
        <div className={`block-container ${attributes.className}`}>
           <div class="block-row">
           <div class="block-col-12" id={`spice_gp_accordion_${uniqueId}`}> 
                            <div className={`spice-gp-accordion-box`} >
                                <div class="spice-gp-accordion-wrap">
                                    <span class="before-icon"><i className={accordionHeadingIcon}></i></span>
                                    <RichText.Content 
                                        tagName="h2"
                                        className= {`spice-gp-accordion` }
                                        value={accordionHeading}
                                        onChange={(userVal) => setAttributes({accordionHeading: userVal})}
                                    />
                                    { AccordionShowIcon == true && [<>
                                    <span class="after-icon-one"><i className={`${AccordionsIconClass.split('_')[0]}`}></i></span>
                                    <span class="after-icon-two"><i className={`${AccordionsIconClass.split('_')[1]}`}></i></span>
                                    </>]}
                                    
                                </div>
                                <div class="spice_panel">
                                    <RichText.Content
                                        tagName="p"
                                        value={accordionContent}
                                        onChange={(userVal) => setAttributes({accordionContent: userVal})}
                                    />
                                </div>
                            </div>
                        </div>
           </div>
        </div>
     </section></>);
     }
})